export interface QuoteRequestPayload {
  companyName: string;
  contactPerson: string;
  phone: string;
  email: string;
  country: string;
  businessDescription: string;
  preferredLanguage?: string;
  selectedPackage?: 'starter' | 'business' | 'premium' | string;
  existingWebsite?: string;
  existingDomain?: string;
  desiredSubdomain?: string;
  socialLinks?: string;
  virtualTourInterest?: boolean;
  aiAssistantInterest?: boolean;
  notes?: string;
  submittedAt: string;
}

export interface QuoteSubmissionResult {
  status: 'recorded_locally' | 'adapter_pending' | 'submitted';
  referenceNumber: string;
  message: {
    ar: string;
    en: string;
  };
}

export interface QuoteSubmissionProvider {
  name: string;
  submitQuoteRequest(payload: QuoteRequestPayload): Promise<QuoteSubmissionResult>;
}

/**
 * Standard Managed-Service Quote Submission Provider
 * Safely captures preliminary lead locally without claiming automated backend provisioning.
 */
export class ManagedServiceQuoteProvider implements QuoteSubmissionProvider {
  name = 'ManagedServiceQuoteProvider';

  async submitQuoteRequest(payload: QuoteRequestPayload): Promise<QuoteSubmissionResult> {
    await new Promise((resolve) => setTimeout(resolve, 700));

    const ref = `SDP-Q-${Date.now().toString(36).toUpperCase()}`;

    try {
      if (typeof window !== 'undefined') {
        const existing = JSON.parse(localStorage.getItem('sdp_preliminary_quotes') || '[]');
        existing.push({ ...payload, referenceNumber: ref });
        localStorage.setItem('sdp_preliminary_quotes', JSON.stringify(existing));
      }
    } catch {
      // safe fallback
    }

    return {
      status: 'recorded_locally',
      referenceNumber: ref,
      message: {
        ar: `تم استلام طلب عرض السعر المبدئي برقم مرجعي: ${ref}. سيقوم فريق JetOwn بمراجعة تفاصيل نشاطكم والتواصل معكم عبر الواتساب أو البريد لإتمام إعداد البروفايل.`,
        en: `Your preliminary quote request was recorded with reference: ${ref}. The JetOwn team will review your business details and contact you via WhatsApp or Email to proceed with profile setup.`,
      },
    };
  }
}
